import allowed from '@/core/constants/allowed-roles.constant'

export const menuItems = {
  core: [
    {
      name: 'core.menu.main.overview',
      icon: 'home',
      route: '/',
      type: 'core',
    },
    {
      name: 'core.menu.main.bradley-ai',
      icon: 'star',
      route: '/bradley-ai',
      opensPanel: 'bradley',
      type: 'core',
    },
    {
      name: 'core.menu.main.my-actions',
      icon: 'check-circle',
      module: 'action-tracker',
      route: '/action-tracker',
      allowedRoles: allowed.action_tracker.roles,
      type: 'core',
    },
    {
      name: 'core.menu.main.my-actions',
      icon: 'check-circle',
      module: 'action-tracker-v2',
      route: '/action-tracker-v2/my-actions',
      allowedRoles: allowed.action_tracker_v2.onlyMyActions,
      type: 'core',
    },

    {
      name: 'core.menu.main.action-tracker',
      icon: 'check-circle',
      module: 'action-tracker-v2',
      type: 'core',
      allowedRoles: allowed.action_tracker_v2.completeSideMenu,
      children: [
        {
          name: 'core.menu.modules.action-tracker-v2-overview',
          route: '/action-tracker-v2/overview',
          type: 'sub',
        },
        {
          name: 'core.menu.modules.action-tracker-v2-my-actions',
          route: '/action-tracker-v2/my-actions',
          type: 'sub',
        },
        {
          name: 'core.menu.modules.action-tracker-v2-action-plans',
          route: '/action-tracker-v2/action-plans',
          type: 'sub',
        },
        {
          name: 'core.menu.modules.action-tracker-v2-module-settings',
          route: '/action-tracker-v2/module-settings',
          type: 'sub',
        },
      ],
    },
    {
      name: 'core.menu.main.targeting-scheduling',
      icon: 'calendar',
      route: '/target-scheduling',
      module: 'targeting-scheduling',
      allowedRoles: allowed.target_scheduling.roles,
      type: 'core',
      children: [
        {
          name: 'core.menu.main.targeting-scheduling-home',
          route: '/target-scheduling',
          allowedRoles: allowed.target_scheduling_home.roles,
          type: 'sub',
        },
        {
          name: 'core.menu.main.spi-goals',
          route: '/target-scheduling/spi-goals',
          allowedRoles: allowed.spi_goals.roles,
          type: 'sub',
        },
        {
          name: 'core.menu.main.safety-observation-goals',
          allowedRoles: allowed.safety_observation_goals.roles,
          route: '/target-scheduling/safety-observation-goals',
          type: 'sub',
        },
      ],
    },
  ],
  modules: [
    {
      name: 'core.menu.modules.culture',
      icon: 'users',
      type: 'module',
      children: [
        {
          name: 'core.menu.modules.coaching-tracker',
          route: '/culture/coaching-tracker',
          module: 'coaching-tracker',
          allowedRoles: allowed.coaching_tracker.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.coaching-tracker-home',
              route: '/culture/coaching-tracker',
              type: 'sub',
            },
          ],
        },
        {
          name: 'core.menu.modules.maturity-grids',
          route: '/culture/maturity-grids',
          module: 'maturity-grids',
          allowedRoles: allowed.maturity_grids.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.maturity-grids-home',
              route: '/culture/maturity-grids',
              type: 'sub',
            },
          ],
        },
        {
          name: 'core.menu.modules.learning-lens',
          route: '/culture/learning-lens',
          module: 'learning-lens',
          allowedRoles: allowed.learning_lens.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.learning-lens-home',
              route: '/culture/learning-lens',
              type: 'sub',
            },
          ],
        },
        {
          name: 'core.menu.modules.sps',
          route: '/sps',
          module: 'sps',
          allowedRoles: allowed.sps.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.sps-home',
              route: '/sps',
              type: 'sub',
            },
          ],
        },
      ],
    },
    {
      name: 'core.menu.modules.risk-exposure',
      icon: 'exclamation-triangle',
      type: 'module',
      children: [
        {
          name: 'core.menu.modules.risk-profiling',
          route: '/risk-exposure/risk-profiling',
          module: 'risk-profiling',
          allowedRoles: allowed.risk_profiling.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.risk-profiling-home',
              route: '/risk-exposure/risk-profiling',
              type: 'sub',
            },
            {
              name: 'core.menu.modules.risk-profiling-mass-import-risks',
              route: '/risk-exposure/risk-profiling/mass-import-risks',
              allowedRoles: allowed.risk_profiling.settings,
              type: 'sub',
            },
            {
              name: 'core.menu.general.module-settings',
              route: '/risk-exposure/risk-profiling/settings/general',
              allowedRoles: allowed.risk_profiling.settings,
              type: 'sub',
            },
          ],
        },
        {
          name: 'core.menu.modules.new-risk-profiling',
          route: '/new-risk-profiling',
          module: 'new-risk-profiling',
          allowedRoles: allowed.new_risk_profiling.roles,
          type: 'sub',
          children: [],
        },
        {
          name: 'core.menu.modules.safety-analytics',
          route: '/risk-exposure/safety-analytics',
          allowedRoles: ['safety-analytics'],
          type: 'sub',
        },
        {
          name: 'core.menu.modules.risk-catalogue',
          route: '/risk-exposure/risk-catalogue',
          module: 'risk-catalogue',
          allowedRoles: allowed.risk_catalogue.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.risk-catalogue-home',
              route: '/risk-exposure/risk-catalogue',
              type: 'sub',
            },
          ],
        },
      ],
    },
    {
      name: 'core.menu.modules.leadership-capabilities',
      icon: 'verified',
      type: 'module',
      children: [
        {
          name: 'core.menu.modules.leadership-assessment',
          route: '/leadership-assessment',
          module: 'leadership-assessment',
          allowedRoles: allowed.leadership_assessment.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.leadership-assessment-admin',
              route: '/leadership-capabilities/leadership-assessment',
              allowedRoles: allowed.leadership_assessment.roles,
              type: 'sub',
            },
          ],
        },
        {
          name: 'core.menu.modules.spi-linewalk',
          route: '/leadership-capabilities/spi-reports',
          module: 'spi',
          allowedRoles: allowed.spi.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.spi-linewalk-home',
              route: '/leadership-capabilities/spi-reports',
              type: 'sub',
            },
            {
              name: 'core.menu.general.module-settings',
              route: '/leadership-capabilities/spi-reports/settings',
              allowedRoles: allowed.spi.settings,
              type: 'sub',
            },
          ],
        },
        {
          name: 'core.menu.modules.stop-safety-observation',
          route: '/leadership-capabilities/safety-observation',
          module: 'safety-observation',
          allowedRoles: allowed.safety_observation.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.stop-safety-observation-home',
              route: '/leadership-capabilities/safety-observation',
              type: 'sub',
            },
            {
              name: 'core.menu.general.module-settings',
              route: '/leadership-capabilities/safety-observation/settings',
              allowedRoles: allowed.safety_observation.settings,
              type: 'sub',
            },
          ],
        },
      ],
    },
    {
      name: 'core.menu.modules.safety-management',
      icon: 'flag',
      type: 'module',
      children: [
        {
          name: 'core.menu.modules.incident-management',
          route: '/safety-management/incident-management',
          module: 'incident-management',
          allowedRoles: allowed.incident_management.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.incident-management-home',
              route: '/safety-management/incident-management',
              type: 'sub',
              allowedRoles: allowed.incident_management.roles,
            },
            {
              name: 'core.menu.modules.incident-management-settings',
              route: '/safety-management/incident-management/settings',
              type: 'sub',
              allowedRoles: allowed.incident_management.settings,
            },
          ],
        },
        {
          name: 'core.menu.modules.unsafe-conditions',
          route: '/safety-management/unsafe-conditions',
          module: 'unsafe-conditions',
          allowedRoles: allowed.unsafe_conditions.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.unsafe-conditions-home',
              route: '/safety-management/unsafe-conditions',
              type: 'sub',
            },
          ],
        },
        {
          name: 'core.menu.modules.work-cycle-verification',
          route: '/safety-management/work-cycle-verification',
          module: 'work-cycle-verification',
          allowedRoles: allowed.wcv.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.work-cycle-verification-home',
              route: '/safety-management/work-cycle-verification',
              type: 'sub',
            },
          ],
        },
        {
          name: 'core.menu.modules.bpo',
          route: '/safety-management/bpo',
          module: 'bpo',
          allowedRoles: allowed.bpo.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.bpo-home',
              route: '/safety-management/bpo',
              type: 'sub',
            },
            {
              name: 'core.menu.modules.bpo-reportability-indicator',
              route: '/safety-management/bpo/reportability-indicator',
              type: 'sub',
            },
            {
              name: 'core.menu.modules.bpo-training-plan',
              route: '/safety-management/bpo/training-plan',
              type: 'sub',
            },
            {
              name: 'core.menu.modules.bpo-training-management',
              route: '/safety-management/bpo/training-management',
              type: 'sub',
              allowedRoles: allowed.bpo.settings,
            },
            {
              name: 'core.menu.modules.bpo-std-indicator',
              route: '/safety-management/bpo/std-indicator',
              type: 'sub',
            },
            {
              name: 'core.menu.modules.bpo-std-management',
              route: '/safety-management/bpo/std-management',
              type: 'sub',
              allowedRoles: allowed.bpo.settings,
            },
            {
              name: 'core.menu.modules.bpo-audits-inspections',
              route: '/safety-management/bpo/audits',
              type: 'sub',
            },
            {
              name: 'core.menu.modules.bpo-form-management',
              route: '/safety-management/bpo/form-management',
              type: 'sub',
              allowedRoles: allowed.bpo.settings,
            },
            {
              name: 'core.menu.modules.bpo-new-audits-inspections',
              route: '/safety-management/bpo/new-audits-inspections',
              type: 'sub',
            },
            {
              name: 'core.menu.modules.bpo-new-form-management',
              route: '/safety-management/bpo/new-form-management',
              type: 'sub',
              allowedRoles: allowed.bpo.settings,
            },
          ],
        },
        {
          name: 'core.menu.modules.bpo-yard-security',
          route: '/safety-management/bpo',
          module: 'bpo',
          allowedRoles: allowed.bpo.surveyjs,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.bpo-yard-security',
              route: '/safety-management/bpo/yard-security',
              type: 'sub',
              allowedRoles: allowed.bpo.surveyjs,
            },
          ],
        },
        {
          name: 'core.menu.modules.training-management',
          route: '/safety-management/training-management',
          module: 'training-management',
          allowedRoles: allowed.training_management.roles,
          type: 'sub',
          children: [
            {
              name: 'core.menu.modules.training-management-home',
              route: '/safety-management/training-management',
              type: 'sub',
            },
          ],
        },
        {
          name: 'core.menu.modules.consultant-site-visit',
          route: '/consultant-companion',
          module: 'consultant',
          allowedRoles: allowed.consultant_visit.roles,
          type: 'sub',
          children: [],
        },
      ],
    },
    {
      name: 'core.menu.modules.survey-tools',
      icon: 'poll',
      type: 'module',
      allowedRoles: allowed.generic_survey.roles,
      children: [
        {
          name: 'core.menu.modules.generic-survey',
          route: '/generic-survey',
          type: 'sub',
          allowedRoles: allowed.generic_survey.roles,
        },
      ],
    },
  ],
}
